import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PubSub from 'pubsub-js';
import { getLinkUrl } from '../services/appservice';
import './ItemEditForm.css';

const ItemEditForm = () => {
    const [pageRefresh, setPageRefresh] = useState(false);
    //const dataStore = new DataStore().getInstance();
    const [formItemLink, setFormItemLink] = useState('');

    const onCloseModal = () => {
        if (pageRefresh) {
            let url = window.location.origin + window.location.pathname + "?m=r";
            window.location.href = url;
        }
    };

    const handleRefresh = (e: any) => {
        console.log("refresh");
        setPageRefresh(e.target.checked);
    };

    const styles = {
        fontFamily: "sans-serif",
        textAlign: "center",
        minHeight: "1000px",
        minWidth: "1000px",
        maxWidth: "100%",
        border: "0",
        width: "100%"
    };

    const mystyle = {
        color: "white",
        padding: "10px",
        fontFamily: "Arial",
        height: "100%",
        width: "100%"
    };


    const successhandler = (data: any, callbackData: any) => {
        var path = data.data.replace('https://contentstudio-g2.ausvtc01.pcf.dell.com', 'https://contentstudio-uxenhancements.r2.pcf.dell.com');
        path = path.replace('http://contentstudio-sitg2.dell.com:1000', 'https://contentstudio-uxenhancements.r2.pcf.dell.com');
        if (callbackData && callbackData.fields && callbackData.fields !== '') {
            path = path + "&fields=" + callbackData.fields;
        }
        setFormItemLink(path);
    };

    const subscriber = (msg: any, data: any) => {
        const itemEditDetails = data;//JSON.parse(data.attributes.itemeditdetails);
        //if (!itemEditDetails.collectionid) {
        //    itemEditDetails.collectionid = dataStore.GetData("CollectionId");
        //}
        //if (!itemEditDetails.itemid) {
        //    itemEditDetails.itemid = dataStore.GetData("ItemId") ? dataStore.GetData("ItemId") : data.attributes.ItemId;
        //    //setting pagetype
        //    if (itemEditDetails.override && itemEditDetails.override === "true") {
        //        if (itemEditDetails.itemid && itemEditDetails.itemid !== "") {
        //            itemEditDetails.pagetype = "itemdashboard";
        //        }
        //        else {
        //            itemEditDetails.pagetype = "collectiondasboard";
        //        }
        //    }
        //}
        getLinkUrl("https://linkstudioapi-sitg1.r2.pcf.dell.com/Api/LinkStudio/GetLink", itemEditDetails, successhandler, data);
    };


    useEffect(() => {
        //PubSub.clearAllSubscriptions();
        const event = PubSub.subscribe("ItemEdit_LoadItemLink", (e: any, dataPublished: any) => subscriber(e, dataPublished));
    }, []);

    const renderHtml = () => {
        return (
            <React.Fragment>
                <div className="modal right fade modal-form" id="modalForm" tabIndex={-1} role="dialog" aria-labelledby="modalForm">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div>
                                    <label htmlFor="refresh" onClick={onCloseModal}>Refresh </label>
                                    <input type="checkbox" className="refresh-margin" id="refresh" name="refresh" onChange={(e) => handleRefresh(e)} />
                                </div>
                                <button type="button" className="close" onClick={onCloseModal} data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                                <iframe id="csIframe" style={mystyle} src={formItemLink}></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }



    return renderHtml();
}

export default connect()(ItemEditForm);
